<template>
  <article class="flex flex-col">
    <h3 class="text-xl font-bold text-gray-700 mb-8">
      <slot name="title"/>
    </h3>
    <div v-if="empty" class="-mt-4">
      <slot name="empty">
        Keine Methoden vorhanden
      </slot>
    </div>
    <ul v-else="empty" role="list" class="bullet-items">
      <PracticeBulletsItem v-for="p in practices" :key="p.id" :practice="p" as="li" />
    </ul>
  </article>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({practices: Array});
const empty = computed(() => props.practices.length == 0);
</script>

<style scoped>
.bullet-items
{
  @apply w-full grid grid-cols-2;
  @apply sm:grid-cols-4 xl:grid-cols-6;
  @apply gap-x-4 gap-y-8;
  @apply md:gap-x-6 lg:gap-x-8 lg:gap-y-12;
  @apply lg:max-w-5xl;
};
</style>